// Entry of the buyer app: the design system's styles, the router, the query client and the service worker.

// Styles first, so the system's layers and tokens precede every CSS Module in the bundle. The fonts are imported
// here, not through styles/index.css, so that the build keeps Archivo and drops the retired IBM Plex faces of
// the same file (vite.config.ts, archivoOnly).
import "../../site/fonts/fonts.css";
import "./styles/index.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorState } from "./features/shell/ErrorState";
import { NotFound } from "./features/shell/NotFound";
import { registerServiceWorker } from "./lib/pwa/register";
import { queryClient } from "./lib/query";
import { routeTree } from "./routeTree.gen";

const router = createRouter({
  routeTree,
  // "/" in the Go web role; "/app" on the public review site (vite.config.ts, base).
  basepath: import.meta.env.BASE_URL.replace(/\/$/, "") || "/",
  context: { queryClient },
  // Pages are fetched when a link is touched, not when it is shown; Query decides what is fresh.
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  // The router's own defaults are English.
  defaultNotFoundComponent: NotFound,
  defaultErrorComponent: ErrorState,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById("root");
if (container === null) throw new Error("index.html has no #root element.");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);

registerServiceWorker();
